import type { ReactNode } from 'react'
import './headerInitialChip.css'

export type HeaderInitialChipSize = 'sm' | 'md'

type Props = {
  /** One or two characters. E.g. `'O'` for Overview, `'EV'` for Evidence. */
  children: ReactNode
  size?: HeaderInitialChipSize
  className?: string
}

const join = (...parts: Array<string | false | null | undefined>) =>
  parts.filter(Boolean).join(' ')

/**
 * Shared page-identity chip. Renders the premium accent-tinted bordered
 * square used at the start of every page header (Overview, Calendar,
 * Design Hub, Automate, Budget, Stock, Reports, Quota, Evidence, …).
 *
 * Self-contained: reads base theme tokens directly (`--accent-primary`,
 * `--surface-elevated`, `--border`, `--text-strong`) with hard fallbacks,
 * so it looks correct whether the ancestor is `.railPageShell`, `.dh-shell`,
 * `.overviewShell`, `.calShell`, or nothing at all.
 */
export const HeaderInitialChip = ({ children, size = 'md', className }: Props) => (
  <span
    className={join('headerInitialChip', `headerInitialChip--${size}`, className)}
    aria-hidden="true"
  >
    {children}
  </span>
)
